import { __awaiter, __generator } from "tslib";
import React, { useState, useEffect } from 'react';
import { getClientConfig, } from '../utils/app-storage';
import { config } from '../config';
import { mmParseUrl } from 'mm-ts-utils-client';
var cfg = getClientConfig();
var BUBBLE_VERSION_KEY = 'bubble_version';
var defaultMessage = 'Nová verzia chatu - pre bezporuchové pokračovanie v rozhovore obnovte prosím prehliadač.';
var NEW_VERSION_MESSAGE = cfg.NEW_VERSION_MESSAGE || defaultMessage;
var NEW_VERSION_CHECK_INTERVAL = parseInt(cfg.NEW_VERSION_CHECK_INTERVAL) || 60000;
export var NewVersionCheck = function () {
    var _a = useState(undefined), storedVersion = _a[0], setStoredVersion = _a[1];
    var _b = useState(false), isUpdateAvailable = _b[0], setIsUpdateAvailable = _b[1];
    // track isMounted state of the component
    var isMounted = React.useRef(false);
    var checkAppVersion = function () { return __awaiter(void 0, void 0, void 0, function () {
        var url, testUrl, response, e_1, data, newAppVersion, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (navigator.onLine === false)
                        return [2 /*return*/]; // do not check for new version if offline
                    url = mmParseUrl();
                    testUrl = "".concat(url.protocol, "//").concat(url.hostname, ":").concat(url.port, "/bubble-status");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(testUrl, {
                            method: 'GET',
                        })];
                case 2:
                    response = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.log('Error fetching health endpoint');
                    return [2 /*return*/];
                case 4:
                    if (!response.ok) return [3 /*break*/, 8];
                    _a.label = 5;
                case 5:
                    _a.trys.push([5, 7, , 8]);
                    if (!isMounted.current)
                        return [2 /*return*/]; // do not update state if component is not mounted
                    return [4 /*yield*/, response.json()];
                case 6:
                    data = _a.sent();
                    newAppVersion = data === null || data === void 0 ? void 0 : data.version;
                    if (!newAppVersion)
                        return [2 /*return*/];
                    if (storedVersion && storedVersion !== newAppVersion) {
                        setIsUpdateAvailable(true);
                    }
                    setStoredVersion(newAppVersion);
                    return [3 /*break*/, 8];
                case 7:
                    e_2 = _a.sent();
                    console.log('Error parsing JSON response from health endpoint');
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isMounted.current = true;
                        return [4 /*yield*/, checkAppVersion()];
                    case 1:
                        _a.sent(); // Check & Set AppVersion on component mount
                        return [2 /*return*/];
                }
            });
        }); })();
        var interval = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, checkAppVersion()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, NEW_VERSION_CHECK_INTERVAL);
        return function () {
            // return cleanup function
            isMounted.current = false;
            clearInterval(interval);
        };
    }, []);
    var message = NEW_VERSION_MESSAGE;
    var reloadText = 'Obnoviť';
    if (isUpdateAvailable) {
        return (React.createElement("div", { className: config.css.B('-new-version-info') },
            React.createElement("span", { className: "".concat(config.css.B('-new-version-info__message')) }, message),
            React.createElement("button", { onClick: function () { return window.location.reload(); }, className: "".concat(config.css.B('-new-version-info__button')) }, reloadText)));
    }
    return null;
};
